module.exports = __webpack_public_path__ + "img/glasbreak-sensor-md.938b2e38.svg";